module.exports = __webpack_public_path__ + "img/icon_favoris.54401d6d.svg";